<template>
  <div v-if="matchCount > 0" class="pdf-find-bar">
    <span class="pdf-find-bar__count">{{ currentMatch }}/{{ matchCount }}</span>
    <BaseRoundButton icon="chevron-up" is-transparent :size="24" @click.native="$emit('previous')" />
    <BaseRoundButton icon="chevron-down" is-transparent :size="24" @click.native="$emit('next')" />
    <BaseRoundButton icon="x" is-transparent :size="24" @click.native="$emit('close')" />
  </div>
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';

export default {
  name: 'PdfFindBar',
  components: { BaseRoundButton },
  props: {
    matchCount: {
      type: Number,
      default: 0,
    },
    currentMatch: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf-find-bar {
  position: sticky;
  top: 8px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 2px;
  background: $color-neutral-pale;
  border-radius: $border-radius-small;
  padding: 2px 8px;
  width: fit-content;
  margin: 0 auto -28px auto;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  &__count {
    font-size: 12px;
    font-family: $font-families;
    color: $color-normal;
    padding: 0 4px;
  }
}
</style>
